module.exports = __webpack_public_path__ + "media/images/electron-453d0c2ff4a97d39af0f0c35f5222a29.svg";